import "./Styles/Loader.css";

export default function Loader() {

    return (
    <div>
<h1 className="loading">Loading<span>...</span></h1>
    </div>)
}